module.exports = __webpack_public_path__ + "img/icon_friends.b7ab8b54.png";